module.exports = __webpack_public_path__ + "static/media/stamp_1.4d3acaf5.png";